import usePutApi from '../api/usePutApi'

function useUpdate (api) {
  const { put, ...state } = usePutApi(api)
  return { ...state, update: put }
}

export default useUpdate
